module.exports = __webpack_public_path__ + "assets/img/sea4.e6c36fea.png";